import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Checkbox } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import PaidIcon from "@mui/icons-material/Paid";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";

const useColumns = (
  setViewProduct,
  setProduct,
  handleViewOpen,
  handleModalOpen
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const columns = [
    {
      Header: "",
      accessor: "checkbox",
      width: "50px",
      disableSortBy: true,
      Cell: ({ row }) => (
        <Checkbox
          checked={selected[row.values.id] || false}
          onChange={() => handleCheckboxChange(row.values.id)}
        />
      ),
    },
    {
      Header: "",
      accessor: "expand",
      width: "100px",
      disableSortBy: true,
      Cell: ({ row }) =>
        row.values.actions ? (
          <IconButton onClick={() => row.toggleRowExpanded()}>
            <ExpandMoreIcon />
          </IconButton>
        ) : null,
    },
    {
      Header: "รูปภาพ",
      accessor: "picture",
      disableSortBy: true,
    },
    { Header: "รหัสรายการ", accessor: "order_code", showInFilter: false },
    { Header: "เลขบัตรประชาชน", accessor: "idcard", showInFilter: false },
    {
      Header: "ชื่อ-นามสกุลผู้ฝาก",
      accessor: "customer_name",
      showInFilter: false,
    },
    { Header: "ยอดฝากขาย", accessor: "pawn_price", showInFilter: false },
    { Header: "วันที่ฝากขาย", accessor: "created_date", showInFilter: false },
    { Header: "วันที่ไถ่ถอน", accessor: "order_due_date", showInFilter: false },
    {
      Header: "Actions",
      accessor: "actions",
      disableSortBy: true,
      Cell: ({ row }) => {
        const orderStatus = row.order_status; // Use optional chaining

        return (
          <div>
            <IconButton onClick={(event) => handleMenuOpen(event, row.id)}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl) && activeRowId === row.id}
              onClose={handleMenuClose}
            >
              <MenuItem
                onClick={() => {
                  setViewProduct(row);
                  handleViewOpen();
                  handleMenuClose();
                }}
              >
                <RemoveRedEyeIcon
                  style={{ marginRight: "8px", color: "#737373" }}
                />
                <span style={{ marginLeft: "8px", color: "#737373" }}>
                  ดูรายละเอียด
                </span>
              </MenuItem>
              {/* Render "View Details" option only if orderStatus is 1 */}
              {orderStatus === 1 && (
                <>
                  <MenuItem
                    onClick={() => {
                      // Uncomment and add logic for printing if needed
                      // console.log("Print action for product ID:", row.original.id);
                      handleMenuClose();
                    }}
                  >
                    <LocalPrintshopIcon
                      style={{ marginRight: "8px", color: "#737373" }}
                    />
                    <span style={{ marginLeft: "8px", color: "#737373" }}>
                      พิมพ์ใบขายฝาก
                    </span>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setProduct(row.original);
                      handleModalOpen();
                      handleMenuClose();
                    }}
                  >
                    <PaidIcon
                      style={{ marginRight: "8px", color: "#737373" }}
                    />
                    <span style={{ marginLeft: "8px", color: "#737373" }}>
                      ต่อดอก
                    </span>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setProduct(row.original);
                      handleModalOpen();
                      handleMenuClose();
                    }}
                  >
                    <SwapHorizontalCircleIcon
                      style={{ marginRight: "8px", color: "#737373" }}
                    />
                    <span style={{ marginLeft: "8px", color: "#737373" }}>
                      ไถ่ถอน
                    </span>
                  </MenuItem>
                </>
              )}

              {/* Render "Edit" option only if orderStatus is not 1 */}
              {/* {orderStatus === 2 && (
                <>
                  <MenuItem
                    onClick={() => {
                      // console.log({ row });
                      setProduct(row);
                      handleModalOpen();
                      handleMenuClose();
                    }}
                  >
                    <ChangeCircleIcon
                      style={{ marginRight: "8px", color: "#737373" }}
                    />
                    <span style={{ marginLeft: "8px", color: "#737373" }}>
                      ปรับต้นทุน
                    </span>
                  </MenuItem>
                </>
              )} */}
            </Menu>
          </div>
        );
      },
    },
  ];
  return columns;
};

export default useColumns;
